import { render, staticRenderFns } from "./MoreScreen.vue?vue&type=template&id=34123f4c&scoped=true&"
import script from "./MoreScreen.vue?vue&type=script&lang=js&"
export * from "./MoreScreen.vue?vue&type=script&lang=js&"
import style0 from "./MoreScreen.vue?vue&type=style&index=0&id=34123f4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34123f4c",
  null
  
)

export default component.exports